import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const invoiceDeclarationApi = createApi({
  reducerPath: "importInvoiceDeclarationApi",
  baseQuery,
  tagTypes: ["ImportInvoiceDeclaration"],
  endpoints: (builder) => ({
    getImportInvoiceDeclaration: builder.query({
      query: ({ id }) => `import/invoice/Declaration/${id}`,
      transformResponse: (response) => response?.data.map((item) => {
        return {
          ...item,
          id: item.declarationId,
          importInvoiceDeclarationType: item.declarationType,
          declarationCode: item.declarationTitle,
        };
      }),
      providesTags: ["ImportInvoiceDeclaration"],
    }),
    createImportInvoiceDeclaration: builder.mutation({
      query: ({ id, ...data }) => {
        return {
          url: `import/invoice/Declaration/${id}`,
          method: "PUT",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: {
            declaration: data,
          },
        };
      },
      invalidatesTags: ["ImportInvoiceDeclaration"],
    }),
    updateImportInvoiceDeclaration: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `import/invoice/Declaration/${id}/${subId}`,
        method: "PUT",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
        body: {
          declaration: data,
        },
      }),
      invalidatesTags: ["ImportInvoiceDeclaration"],
    }),
    deleteImportInvoiceDeclaration: builder.mutation({
      query: ({ id }) => ({
        url: `import/invoice/Declaration/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2),
        },
      }),
      invalidatesTags: ["ImportInvoiceDeclaration"],
    }),
  }),
});

export const {
  useGetImportInvoiceDeclarationQuery,
  useLazyGetImportInvoiceDeclarationQuery,
  useCreateImportInvoiceDeclarationMutation,
  useUpdateImportInvoiceDeclarationMutation,
  useDeleteImportInvoiceDeclarationMutation,
} = invoiceDeclarationApi;
